import React, { useEffect, useMemo, useState } from 'react'
import WOService from 'src/Services/API/wo.service'

const getWoIdFromPath = () => {
  if (typeof window === 'undefined') return null

  const pathMatch = window.location.pathname.match(/\/form-builder\/(\d+)/)
  if (pathMatch?.[1]) return Number(pathMatch[1])

  const searchParams = new URLSearchParams(window.location.search)
  const woIdFromQuery = Number(searchParams.get('woId'))
  return Number.isNaN(woIdFromQuery) ? null : woIdFromQuery
}

const resolveWorkOrderId = (woIdProp) => {
  const parsedProp = Number(woIdProp)
  if (!Number.isNaN(parsedProp) && parsedProp > 0) return parsedProp

  if (typeof window === 'undefined') return getWoIdFromPath()

  const fromWindow = Number(window.__makaniFormWoId)
  if (!Number.isNaN(fromWindow) && fromWindow > 0) return fromWindow

  return getWoIdFromPath()
}

const TechnicianDropdown = ({
  value,
  onChange,
  readOnly = false,
  disabled = false,
  label = 'Technician',
  placeholder = 'Select Technician',
  woId,
}) => {
  const [technicians, setTechnicians] = useState([])
  const [loading, setLoading] = useState(false)
  const [resolvedWoId, setResolvedWoId] = useState(() => resolveWorkOrderId(woId))
  const [localSelectedValue, setLocalSelectedValue] = useState('')

  useEffect(() => {
    setResolvedWoId(resolveWorkOrderId(woId))
  }, [woId])

  useEffect(() => {
    if (resolvedWoId) return undefined

    const interval = setInterval(() => {
      const nextWoId = resolveWorkOrderId(woId)
      if (nextWoId) {
        setResolvedWoId(nextWoId)
        clearInterval(interval)
      }
    }, 500)

    return () => clearInterval(interval)
  }, [resolvedWoId, woId])

  useEffect(() => {
    let isMounted = true

    if (!resolvedWoId) {
      setTechnicians([])
      return () => {
        isMounted = false
      }
    }

    setLoading(true)
    WOService.getAssignedTechniciansByWoId(resolvedWoId)
      .then((response) => {
        if (!isMounted) return
        const payload = Array.isArray(response?.data) ? response.data : []
        setTechnicians(payload)
      })
      .catch(() => {
        if (!isMounted) return
        setTechnicians([])
      })
      .finally(() => {
        if (isMounted) setLoading(false)
      })

    return () => {
      isMounted = false
    }
  }, [resolvedWoId])

  const selectedValue = useMemo(() => {
    if (value === undefined || value === null) return ''
    return String(value)
  }, [value])

  useEffect(() => {
    setLocalSelectedValue(selectedValue)
  }, [selectedValue])

  const isDisabled = disabled || readOnly || loading || !resolvedWoId

  return (
    <div style={{ width: '100%' }}>
      <label
        style={{
          display: 'block',
          fontSize: 12,
          fontWeight: 400,
          marginBottom: 6,
          color: '#1f2937',
        }}
      >
        {label}
      </label>

      <select
        value={localSelectedValue}
        disabled={isDisabled}
        onChange={(event) => {
          const nextValue = event.target.value
          setLocalSelectedValue(nextValue)
          onChange?.(nextValue)
        }}
        style={{
          width: '100%',
          height: 36,
          border: '1px solid #d1d5db',
          borderRadius: 6,
          padding: '0 10px',
          fontSize: 14,
          backgroundColor: isDisabled ? '#f3f4f6' : '#ffffff',
          color: '#111827',
        }}
      >
        <option value="" disabled hidden>
          {loading ? 'Loading technicians...' : placeholder}
        </option>
        {technicians.map((tech) => (
          <option key={tech.id} value={String(tech.id)}>
            {tech.name}
          </option>
        ))}
      </select>
    </div>
  )
}

export default TechnicianDropdown
